// extracted by mini-css-extract-plugin
module.exports = {"container":"bannerHeader_container__JAqti","header":"bannerHeader_header__elL3z","title":"bannerHeader_title__222UH","text":"bannerHeader_text__2L_mC"};